<div class="rbr-section">
    <ng-content />
</div>
